export class Modifier {
	id: number = null; // Id indentity
	modifierId: number = null;
	menuModifierGroupId: number = null;
	name: string = null;
	price: number = null;
	quantity: number = null;
	discount: number = null;
	isPrintedToKitchen: boolean = false;
	selected?: boolean = false;
	subTotal?: number = null;
	isSpecial?: boolean = false;
	itemId?: number = null;
}

export interface ParentModifierGroup {
	id: number;
	name: string;
}

export interface FilterModifier {
	id: number;
	action: FilterModifierBy;
}

export enum FilterModifierBy {
	by_item_id = "by_item_id",
	by_parent_group_id = "by_parent_group_id",
	menuModifierGroupId = "menuModifierGroupId",
	menuModifierGroupsByItemId = "menuModifierGroupsByItemId",
	menuModifierGroupsByParentId = "menuModifierGroupsByParentId"
}
